import { useApiAction } from '../../api/useApiAction'
import { Note, state } from '../../utils/types'
import { StatusScreenWrapper } from '../common/statusScreenWrapper'
import { getPendingTimeAlert } from './functions'
import KycStatus from './kycContent'
import VideoKyc from './videoKyc'

interface ContentProps {
  state: state
  props: {
    type: string
    title: string
    subTitle: string
    kycSteps: {
      title: string
      subTitle: string
      show: string[]
    }[]
    note?: Note
    buttons?: any[]
    steps: Array<{ title: string; subTitle: string; show: string[] }>
  }
}

export const KycInfo: React.FC<ContentProps> = (_props) => {
  const { state, props } = _props

  const { mutate, data, isLoading } = useApiAction()

  const expiryTimeEpochInMillis = data?.metadata?.kycExpiryTime

  const pendingTime = getPendingTimeAlert(
    expiryTimeEpochInMillis,
    data?.metadata?.userKycType,
    Boolean(data?.metadata?.c1Id)
  )
  let buttons = props?.buttons
  if (data?.metadata?.partnerId == 299) {
    buttons = data?.metadata?.isVkycAvailable
      ? props?.buttons?.map((button) => ({ ...button, disabled: true }))
      : props?.buttons
  } else {
    buttons =
      !pendingTime || pendingTime?.isExpired
        ? props?.buttons?.map((button) => ({ ...button, disabled: true }))
        : props?.buttons
  }
  const description = data?.layout?.description?.replace(
    /{(.*?)}/g,
    (_: string, key: string) => data?.metadata[key] || `{${key}}`
  )

  return (
    <StatusScreenWrapper
      Content={
        props?.type === 'video_kyc' ? (
          <VideoKyc
            title={data?.layout?.title}
            subTitle={description}
            applicationNumber={data?.metadata?.arnNumber}
            insideWorkingHours={true}
            thingsToCarry={[
              'Keep your original physical PAN card with you',
              'Keep a blank white paper with black/blue pen',
              'Ensure ample light and a clear background',
              'Ensure a stable network connection',
            ]}
            kycSteps={[
              {
                title: 'Video KYC',
                subTitle: 'Online Video KYC using phone camera',
                icon: 'CameraOutlined',
              },
            ]}
          />
        ) : (
          <KycStatus
            kycSteps={props?.steps}
            title={props?.title}
            subTitle={props?.subTitle}
            kycType={data?.metadata?.userKycType}
            c1Id={data?.metadata?.c1Id}
            pendingTime={pendingTime?.pendingTimeText}
          />
        )
      }
      consent={[
        '<p>I hereby give my consent terms and conditions of HDFC Bank Limited to complete my KYC through thevideo based customer identification process (V-CIP) as Prescribed by RBI.</p>',
        '<p>By clicking on “Continue with Video KYC” I understand and acknowledge <a href="https://www.hdfcbank.com/personal/useful-links/privacy" target="_blank" style="text-decoration: underline; color: #596379; font-weight: bold;">HDFC Bank Privacy Policy</a></p>',
      ]}
      state={state}
      buttons={buttons}
      mutate={mutate}
      isLoading={isLoading}
    />
  )
}
